/**
 * Use this in any top-level init code where we want to be disciplined about not running application
 * code at import time. Importing this file sets the system into an importing state, and
 * markInitialImportFinished should be called when the initial import has finished and application
 * code is now allowed. Custom init code paths can avoid init tracking assertions by simply never
 * importing this file.
 *
 * Example usage:
 *
 * import {markInitialImportFinished} from 'util/start-import-tracker';
 * [All of the real imports]
 * markInitialImportFinished();
 */
import {markInitialImportFinished, markInitialImportStarted} from 'util/ImportTracker';

markInitialImportStarted();

export {markInitialImportFinished};
